import UserProfileService from './UserProfileService';
import type { UserProfile } from './UserProfileService';

export default UserProfileService;
export type { UserProfile };
